import Box from '@mui/material/Box';

const MyContact = () => {

    return <Box id="Contact" className="container" sx={{ width: 'auto', p: 2}}>
        <Box component="h1" mt={0} className='text-shadow'>Contact</Box>
        <Box display={'flex'} flexDirection="row" alignitems={'center'} justifyContent={'space-between'}>
            <Box display={'flex'} flexDirection={'column'}>
                <Box component="h6" mt={0} mb={1}>Address:</Box>
                <Box component="span" className='text-sm'>
                    #27/12/2000, Peer Nagar<br /> Ghazipur, UP India - 233300
                </Box>
            </Box>
            <Box component="span" className='text-sm' sx={{textAlign: 'center'}}>All Right Reserved. <br/>pridim@2025</Box>
            <Box display={'flex'} flexDirection={'column'}>
                <Box component="h6" mt={0} mb={1}>Call/SMS or Email</Box>
                <Box component="span" className='text-sm'>
                    +91 8686340975
                </Box>
                <Box component="span" className='text-sm'>
                    rgupta@pridim.com
                </Box>
            </Box>
        </Box>
    </Box>
}

export default MyContact;
